const t = (t2) => {
  const [e, s] = t2.split(/\.(?=[^.]+$)/);
  return e.length <= 50 ? t2 : e.slice(0, 50) + "...." + s;
};
export {
  t as default,
  t as getShortName
};
//# sourceMappingURL=getShortName.js.map
